import React from 'react'
import {Link} from "react-router-dom";
import apiaddressredirect from "../apiaddressredirect.json";

class MenuBar extends React.Component {	  
	render() {
		return(			
			<div id="buttons">
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/">HOME</Link></label>
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = {{pathname: apiaddressredirect.IPAddress+"Apply"}} target="_blank">APPLY</Link></label>				
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = {{pathname: apiaddressredirect.IPAddress+"Member"}} target="_blank">MEMBER</Link></label>
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Career">CAREER</Link></label>
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Questions">QUESTION</Link></label>
				<label style={{width: '120px',display:'inline-block',textAlign:'center',padding:'10px 0'}}><Link to = "/Contact">CONTACT</Link></label>			
			</div>			
		)
	}
}

export default MenuBar